import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { ArrowIcon } from "@common/assets/arrowIcon";
import { SelectList } from "@common/selectList";
import { SortOption } from "../../types";
import { Props } from "./type";
import styles from "./styles.scss";

function SortDropdown(props: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.sortDropdown}>
      <div className={styles.title}>
        <p>{t("planzoneMembersPage.sorters.title")}</p>
      </div>
      <SelectList rootClassName={styles.root} listClassName={styles.listRoot}>
        {({ isOpen, select }) => ({
          input: (
            <div
              className={classNames(styles.input, {
                [styles.opened]: isOpen,
              })}
            >
              <p>{t(props.sortElement)}</p>
              <ArrowIcon className={styles.icon} />
            </div>
          ),
          list: (
            <div className={styles.list}>
              <div>
                {Object.values(SortOption).map((option) => (
                  <div
                    key={option}
                    className={classNames(styles.option, {
                      [styles.selected]: props.sortElement === option,
                    })}
                    onClick={() => select(props.setSorter(option))}
                  >
                    <p>{t(option)}</p>
                  </div>
                ))}
              </div>
            </div>
          ),
        })}
      </SelectList>
    </div>
  );
}

export { SortDropdown };
